import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import history from "../../history";
import { postDiscAssessmentTest } from "../../redux/actions/psychometricTestsActions";
import * as styles from "./styles.module.scss";
import ProgressBar from "../MyTests/ProgressBar";

const DiscAssessment = ({ appData, postDiscAssessmentTestFunc }) => {
  const name = `${appData.firstName} ${appData.lastName}`;
  const questions = [
    {
      question: "I hesitate to criticize other people's ideas.",
      factor: "3",
    },
    {
      question: "I enjoy being part of a loud crowd.",
      factor: "2",
    },
    {
      question: "I put people under pressure.",
      factor: "1",
    },
    {
      question: "I am emotionally reserved.",
      factor: "4",
    },
    {
      question: "I read the fine print.",
      factor: "4",
    },
    {
      question: "I value cooperation over competition.",
      factor: "3",
    },
    {
      question: "I want strangers to love me.",
      factor: "2",
    },
    {
      question: "I have a strong need for power.",
      factor: "1",
    },
    {
      question: "I joke around a lot.",
      factor: "2",
    },
    {
      question: "I just want everyone to be equal.",
      factor: "3",
    },
    {
      question: "I try to outdo others.",
      factor: "1",
    },
    {
      question: "I love order and regularity.",
      factor: "4",
    },
    {
      question: "My first reaction to an idea is to see its flaws.",
      factor: "4",
    },
    {
      question: "I am always on the look out for ways to make money.",
      factor: "1",
    },
    {
      question: "I make lots of noise.",
      factor: "2",
    },
    {
      question: "I seldom toot my own horn.",
      factor: "3",
    },
  ];
  const scale = {
    Disagree: 1,
    "Slightly Disagree": 2,
    Neutral: 3,
    "Slightly Agree": 4,
    Agree: 5,
  };
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswer] = useState([{}]);
  const [chosen, setChosen] = useState("");
  const [progress, setProgress] = useState(0);
  const progressCalculation = Math.round(
    (currentQuestion / questions.length) * 100
  );
  const updateProgress = () => {
    setProgress(progressCalculation);
  };
  const nextQuestion = () => {
    const next = answers[currentQuestion + 1];
    setCurrentQuestion(currentQuestion + 1);
    setChosen(Object.keys(scale)[next - 1] || "");
    updateProgress();
  };
  const previousQuestion = () => {
    const previous = answers[currentQuestion - 1];
    setCurrentQuestion(currentQuestion - 1);
    setChosen(Object.keys(scale)[previous - 1] || "");
    updateProgress();
  };
  const storeAnswer = (questionNumber, chosenAnswer) => {
    setChosen(chosenAnswer);
    setAnswer({
      ...answers,
      [questionNumber - 1]: scale[chosenAnswer],
    });
  };
  const loadChosen = () => {
    const answerScale = answers[currentQuestion - 1];
    setChosen(Object.keys(scale)[answerScale - 1]);
  };
  const handleSubmit = async () => {
    postDiscAssessmentTestFunc(answers, name);
    history.push("/profile/MyTests/results", {
      testName: "discAssessment",
      pdfName: "DISCAssessmentTestFeedback.pdf",
    });
  };
  const handleOptionButton = (e) => {
    storeAnswer(currentQuestion + 1, e.target.value);
    if (currentQuestion !== questions.length - 1) {
      setTimeout(() => {
        nextQuestion();
      }, 800);
    }
  };
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div style={{ padding: "5%" }} className="col-sm-9 col-lg-8">
        <div className={styles.mainSection}>
          <h2>Disc Assessment Test</h2>
          {ProgressBar(progressCalculation)}
        </div>
        <div>
          <section className="section-body p-1">
            <p className="mb-2">Please select one answer for each question.</p>
            <article>
              <div className={styles.mainContainer}>
                <h4 className={styles.legendContainer}>
                  <div className={styles.question}>
                    Question {currentQuestion + 1} / {questions.length}
                  </div>
                  <div>{questions[currentQuestion].question}</div>
                </h4>
                <div className={styles.optionsContainer}>
                  {Object.keys(scale).map((key, i) => {
                    return (
                      <label
                        key={i}
                        onClick={(event) => handleOptionButton(event)}
                        className={styles.optionChoice}
                      >
                         {" "}
                        <input
                          style={{ marginRight: "5px" }}
                          checked={chosen === key}
                          type="radio"
                          id="html"
                          value={key}
                        />
                        {key}
                      </label>
                    );
                  })}
                </div>
              </div>
            </article>
            <div className={styles.testButtons}>
              {questions[currentQuestion] === questions[0] ? (
                <button
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                  onClick={() => history.push("/profile/MyTests")}
                >
                  Cancel
                </button>
              ) : (
                <button
                  onClick={() => {
                    loadChosen();
                    previousQuestion();
                  }}
                  style={{ minWidth: "fit-content" }}
                  className="btn btn-outline-dark text-orange col-12 col-sm-3 col-lg-2 my-2"
                >
                  Change previous answer
                </button>
              )}
              {currentQuestion === questions.length - 1 && (
                <button
                  disabled={!chosen || chosen === ""}
                  onClick={handleSubmit}
                  id="btnBasicInfoEditSubmit"
                  className="btn btn-primary col-12 col-sm-3 col-lg-2 my-2"
                >
                  Finish
                </button>
              )}
            </div>
            <div className="d-flex w-full justify-content-end">
              <Link
                to="/profile/MyTests"
                className="btn btn-outline-dark text-dark col-12 col-sm-3 col-lg-2 my-2 hover-text-white"
              >
                My Tests
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
const mapDispatchToProps = {
  postDiscAssessmentTestFunc: postDiscAssessmentTest,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(DiscAssessment);
